import type { TFunction } from 'i18next';

const minute = 60;
const hour = 60 * minute;
const day = 24 * hour;
const month = 30 * day;
const year = 365 * day;

/**
 * Short human form of a rest interval, such as "10 мин" or "1,5 мес". Coarse
 * on purpose: it tells the learner roughly when the card comes back, not the
 * exact moment.
 */
export function formatInterval(seconds: number, t: TFunction, language: string): string {
  const number = (value: number): string =>
    new Intl.NumberFormat(language, { maximumFractionDigits: value < 10 ? 1 : 0 }).format(value);

  if (seconds < minute) {
    return t('units.underMinute');
  }

  if (seconds < hour) {
    return t('units.minutes', { value: Math.round(seconds / minute) });
  }

  if (seconds < day) {
    return t('units.hours', { value: Math.round(seconds / hour) });
  }

  if (seconds < month) {
    return t('units.days', { value: Math.round(seconds / day) });
  }

  if (seconds < year) {
    return t('units.months', { value: number(seconds / month) });
  }

  return t('units.years', { value: number(seconds / year) });
}
